async function getSampleMap(id) {
    return fetch(`/api/sampleMaps/${id}`, {
        method: 'GET',
    });
}

async function updateSampleMap(id, properties) {
    return fetch(`/api/sampleMaps/${id}`, {
        method: 'PATCH',
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify(properties)
    });
}

export {
    getSampleMap,
    updateSampleMap
}